import { Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export function PurchasesEmptyState() {
  const [t] = useTranslation();
  return (
    <Flex width="100%" justifyContent="center" p="24px">
      <Text
        fontFamily="Bricolage Grotesque"
        fontSize="20px"
        letterSpacing=".5px"
        fontWeight="700"
        color="dune.dune"
      >
        {t("screens.purchases.emptyState")}
      </Text>
    </Flex>
  );
}
